import { api } from '../../../services/api'

export const fetchRetornarEmData = async (codUsuario) => {
  const response = await api.get('/site/v2/orcamento-crm/listar-agendamentos-telefone', {
    params: {
      codigo_usuario: codUsuario,
    },
  })

  const data = response.data

  return data.agendamentos.map((item, index) => ({
    ...item,
    id: index + 1,
    cliente: item.cliente,
    dataRetorno: `${item.data} ${item.horario}`,
    proposta: item.proposta,
    verba: item.verba,
  }))
}
